export const GET_LEAD = 'GET_LEAD'
export const GET_LEAD_ERR = 'GET_LEAD_ERR'
export const GET_ANALYSIS = 'GET_ANALYSIS'
export const GET_ANALYSIS_ERR = 'GET_ANALYSIS_ERR'
export const GET_REASON_LIST = 'GET_REASON_LIST'
export const GET_REASON_LIST_ERR = 'GET_REASON_LIST_ERR'
